export default __webpack_public_path__ + "static/media/youtube gold play button.29a384a7.png";